(function() {
  function initPlpFilters() {
    var priceFilters = $('.filters [data-price]');
    if (!priceFilters.length) return;

    priceFilters
      .sort(function(a, b) {
        var priceA = $(a).data('price').split('-')[0];
        var priceB = $(b).data('price').split('-')[0];

        if (/^[a-zA-Z]+$/i.test(priceA)) {
          return false;
        }
        if (/^[a-zA-Z]+$/i.test(priceB)) {
          return true;
        }
        return parseInt(priceA, 10) > parseInt(priceB, 10);
      })
      .appendTo($('.filters [data-price]').parent());
  }

  window.initPlpFilters = initPlpFilters;

  $(function() {
    initPlpFilters();
  });
})();
